import { PatientAppointment } from '../../../services/appointment/types';

import { Box } from '@mui/system';
import moment from 'moment';
import { ListItem } from '../../layout/slideout/patient-profile-widget/patient-profile-widget.styles';
import { getSpentChip } from '../../layout/slideout/patient-profile-widget/views/visits/utils/get-spent-chip';
import { PastApptTitle } from './appointment.styles';

type PastAppointmentItemProps = {
  appointment: PatientAppointment;
  onClick: (appointment: PatientAppointment) => void;
};

export const PastAppointmentItem = ({ appointment, onClick }: PastAppointmentItemProps) => {
  return (
    <ListItem key={appointment.id} onClick={onClick}>
      <PastApptTitle className='past-appointment-title'>
        {appointment.date ? moment(appointment.date).format('MM/DD/YYYY') : null}
        {getSpentChip(appointment)}
      </PastApptTitle>
      <Box sx={{ paddingTop: '4px', fontSize: '14px' }}>{appointment.description}</Box>
    </ListItem>
  );
};
